import {DateTime} from 'luxon';
import React, {FC} from 'react';

import {build12Or24hOptionsForFormat, TimeFormatsEnum} from '../../../src/helpers/dateTimeHelpers';
import {DateTimeFormatterBase} from './dateTimeFormatterBase';

/*
 * Constants.
 */

const sameDayFormat: Intl.DateTimeFormatOptions = {
  hour: 'numeric',
  minute: 'numeric',
};

const otherDayFormat: Intl.DateTimeFormatOptions = {
  ...sameDayFormat,
  weekday: 'short',
  month: 'short',
  day: 'numeric',
  year: 'numeric',
};

/*
 * Props.
 */

interface SmartDateTimeFormatterProps {
  /** The date to format. */
  value: number;
  /** Whether we should display 12h or 24h time. */
  timeFormat?: TimeFormatsEnum;
  /** A custom format for the time, this will override the smart select. */
  customFormat?: Intl.DateTimeFormatOptions;
}

/*
 * Component.
 */

export const SmartDateTimeFormatter: FC<SmartDateTimeFormatterProps> = ({
  value,
  timeFormat,
  customFormat,
}) => {
  const date = new Date(value);
  const format = customFormat ?? getSmartDateTimeFormat(date, timeFormat);
  return <DateTimeFormatterBase value={date} format={format} />;
};

/*
 * Helpers.
 */

function getSmartDateTimeFormat(date: Date, timeFormat: TimeFormatsEnum | undefined) {
  const now = DateTime.local();
  const then = DateTime.fromJSDate(date);
  const isSameDay = now.hasSame(then, 'day');
  const format = isSameDay ? sameDayFormat : otherDayFormat;
  const clockFormat = (timeFormat && build12Or24hOptionsForFormat(timeFormat)) || {};

  return {
    ...format,
    ...clockFormat,
  };
}
